import company1 from "../../../assets/company1.png";
import college from "../../../assets/college.png";
import swiggy from "../../../assets/swiggy.png"

export const experiences = [
    {
        companyLogo: swiggy,
        companyName: 'Swiggy',
        role: 'Associate Software Developement Engineer',
        
        workPoints: [
            `Working to Deliver products under 10 mins through Instamart with enhanced user experience and interaction.`,
            `Enabled Cart widgets of Flash sale and Last Minute Add ons to drive AOV contribution by +.53p.`,
            `Enabling FE to BE Couponless Migration to reduce chunk size and lazy loaded coupons.`,
            `Revamped Category Listing and Search Page which drives an overall 0.6% increase in A2C(Add to Cart).`
          
        ],
        date: 'Jan 2024 - Present',
      },
    {
        companyLogo: swiggy,
        companyName: 'Swiggy',
        role: 'Software Developer Intern',
        
        workPoints: [
           'Development of an Value Perception Widget for the homepage, driving a daily average increase of 2,000 orders.',
            'Created a dynamic animation resulting in a significant 4% boost in Click-Through Rates (CTR) for a new feature.',
            'Enhanced system reliability through bug resolution, comprehensive unit tests, and UI/UX improvements.',
        ],
        date: 'Oct 2023 - Dec 2023',
      },
    {
      companyLogo: company1,
      companyName: 'C-DAC',
      role: 'Software Intern',
      
      workPoints: [
        'Worked in Android Studio, Machine Learning, Python and Java.',
        'Developed Proof of Concept of Advanced Teacher Attendance Monitoring System Application in Android Studio.',
        'Security: Combined facial recognition, biometrics, and GPS to attain 95% teacher identification accuracy.',
        'Efficiency: Managed real-time data for 500+ teachers through Firebase integration, showcasing scalability.',
        'Precise Location Verification: Achieved accurate attendance tracking by integrating GPS validation.',
        'Worked across projects in Python and Java for adding new features',
        'Made Machine Learning models, fixed bugs and debugged Python codes.'
      ],
      date: 'Jan 2022 - May 2022',
    },
    // Add more experience items here
    {
      companyLogo: college,
      companyName: 'NIT Kurukshetra',
      role: 'B.Tech',
      
      workPoints: [
        'Graduation in Electronics and Communication Engineering.',
        'CGPA : 8.9/10'
      ],
      date: 'June 2019 - June 2023',
    }
  ];